<template>
  <div class="lunbo-wrap" v-if="imgList">
    <div class="show-image" :style="{'background-image': 'url(' + imgList[currentImgIndex].path + ')'}">
      <div
              class="left-arrow arrow"
              v-if="imgList.length > 1"
              @click="prevImg"
      >
      </div>
      <div
              class="righ-arrow arrow"
              v-if="imgList.length > 1"
              @click="nextImg"
      >
      </div>
    </div>
    <div class="img-list" v-if="pics.length > 4">
      <div class="arrow l-left" @click="scrollPrev"></div>
      <template v-for="(item, index) in imgList">
        <div
                class="img-a"
                :class="{active: currentImgIndex === index}"
                v-show="item.show"
                :key="index"
                :style="{'background-image': 'url(' + item.path + ')'}"
                @click="showImg(index)"
        >
        </div>
      </template>
      <div class="arrow l-right" @click="scrollNext"></div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    props: {
      pics: {
        type: Array
      }
    },
    components: {

    },
    data () {
      return {
        currentImgIndex: 0,
        scrollIndex: 0,
        imgList: []
      }
    },
    created () {
      this.reSetImgList()
    },
    methods: {
      reSetImgList () {
        let neww = this.pics.concat(this.pics.slice(0, 3))
        let res = JSON.parse(JSON.stringify(neww))
        for(var i = 0; i < neww.length;i++){
          if(i < 4){
            res[i].show = true
          }else{
            res[i].show = false
          }
        }
        this.imgList = res
      },
      prevImg () {
        let len = this.imgList.length
        let cur = this.currentImgIndex
        if(cur === 0){
          this.currentImgIndex = len - 1
        }else{
          this.currentImgIndex = this.currentImgIndex - 1
        }
      },
      nextImg () {
        let len = this.imgList.length
        let cur = this.currentImgIndex
        if(cur === len - 1){
          this.currentImgIndex = 0
        }else{
          this.currentImgIndex = this.currentImgIndex + 1
        }
      },
      showImg (index) {
        this.currentImgIndex = index
      },
      setImgList (num) {
        this.imgList.forEach((item, index) => {
          if(index === num || index === num + 1 || index === num + 2 || index === num + 3){
            this.$set(this.imgList[index], 'show', true)
          }else{
            this.$set(this.imgList[index], 'show', false)
          }
        })
      },
      scrollPrev () {
        let len = this.pics.length
        let cur = this.scrollIndex
        if(cur === 0){
          this.scrollIndex = len - 1
        }else{
          this.scrollIndex = this.scrollIndex - 1
        }
        this.setImgList(this.scrollIndex)
      },
      scrollNext () {
        let len = this.pics.length
        let cur = this.scrollIndex
        if(cur === len - 1){
          this.scrollIndex = 0
        }else{
          this.scrollIndex = this.scrollIndex + 1
        }
        this.setImgList(this.scrollIndex)
      }
    }
  }
</script>

<style scoped lang="less">
  .lunbo-wrap{
    .show-image{
      position: relative;
      padding-bottom: 54.8%;
      width: 100%;
      height: 0;
      background-color: #eee;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      transition: all .3s;
      .arrow{
        position: absolute;
        top: 50%;
        margin-top: -40px;
        width: 40px;
        height: 80px;
        background-color: rgba(0, 0, 0, .3);
        background-repeat: no-repeat;
        background-position: center;
        background-size: 20px;
        cursor: pointer;
        &.left-arrow{
          left: 0;
          background-image: url('../../../assets/images/lb_arrow_left.png');
        }
        &.righ-arrow{
          right: 0;
          background-image: url('../../../assets/images/lb_arrow_right.png');
        }
      }
    }
    .img-list{
      position: relative;
      font-size: 0;
      text-align: center;
      .arrow{
        position: absolute;
        top: 50%;
        margin-top: calc(-5.615% + 5px);
        padding-bottom: 11.23%;
        width: 2.8%;
        height: 0;
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
        &:hover{
          background-color: rgba(0, 0, 0, .3);
        }
        &.l-left{
          left: 0;
          background-image: url('../../../assets/images/lb_arrow_left.png');
        }
        &.l-right{
          right: 0;
          background-image: url('../../../assets/images/lb_arrow_right.png');
        }
      }
      .img-a{
        display: inline-block;
        padding-bottom: 11.23%;
        margin: 10px 5px 0;
        width: 20.5%;
        height: 0;
        cursor: pointer;
        background-color: #eee;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        &.active,
        &:hover{
          position: relative;
          &:after{
            position: absolute;
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            border: 2px solid #999;
          }
        }
      }
    }
  }
</style>
